import React from 'react';
import { classNames } from '../../Services/helpers';

const Badge = ({title, theme, className}) => {

    const themes = {
        'secondary': 'bg-gray-500/10 text-gray-500 fill-gray-500 ring-gray-500',
        'danger': 'bg-red-500/10 text-red-500 fill-red-500 ring-red-500',
        'warning': 'bg-orange-500/10 text-orange-500 fill-orange-500 ring-orange-500',
        'info': 'bg-blue-500/10 text-blue-600 fill-blue-600 ring-blue-600',
        'success': 'bg-green-500/10 text-green-500 fill-green-500 ring-green-500',
        'brand': 'bg-brand/10 text-brand fill-brand ring-brand',
    }

    const classes = classNames(
        'inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset shrink',
        theme && (themes[theme] ?? themes['secondary']),
        className,
    );

    return <span className={classes}>
        {title}
    </span>
}

export default Badge;
